import { fitPercent } from "./existingLeaves";
import { leafLabel } from "./kindWords";
import { asReviewRow, type RowInput } from "./reviewRow.types";

export type PickWhyView = {
  why: string;
  alsoTried: string | null;
  copy: { text: string; ignore: boolean } | null;
};

const copyAction = (label: string | undefined, required: boolean) =>
  !label
    ? null
    : required
      ? {
          text: `It's a copy of ${label} — keep it store-only: choose One store only below, then Approve.`,
          ignore: false,
        }
      : { text: `It's a copy of ${label} — ignore`, ignore: true };

export function pickWhy(
  input: RowInput,
  required: boolean,
): PickWhyView | null {
  const row = asReviewRow(input);
  const rejection = row.leafRejection;
  if (!rejection) return null;
  const fit = fitPercent(rejection.rejected_p);
  const tried = rejection.rejected_leaf
    ? leafLabel(rejection.rejected_leaf)
    : null;
  return {
    why: rejection.reason,
    alsoTried: tried && `${tried}${fit === null ? "" : ` ${fit}%`}`,
    copy: copyAction(rejection.copy_of?.label, required),
  };
}

export const lostWordsNote = (count: number) =>
  count ? `${count} value${count === 1 ? "" : "s"} lost a word.` : "";

export function pickSentence(input: RowInput): string | null {
  const row = asReviewRow(input);
  const rejection = row.leafRejection;
  if (!rejection) return null;
  return rejection.copy_of
    ? "Another field already uses this target. It may also be a copy."
    : "The first pick was sent back.";
}
